import {Classes, Overlay} from '@blueprintjs/core';
import React, {PureComponent} from 'react';
import ReactIntlTelInput from 'react-intl-tel-input-v2';
import ReactCodeInput from 'react-verification-code-input';
import toastr from 'toastr';
import {getCurrentUserId, getJwt} from '../../services/authService';
import http from '../../services/httpService';
import InputNotification from '../common/InputNotification';
import InputRegular from '../common/InputRegular';

class VerifyNumberModal extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 1,
            friendlyName: '',
            phone: {
                iso2: 'us',
                dialCode: '1',
                phone: ''
            },
            formatedPhone: '',
            oldFormatedPhone: '',
            phoneVerified: '',
            phoneId: '',
            overlayIsOpen: false,
            errorsList: [],
            fieldsCheckActive: false,
            spinnerActive: false,
            codeInvalid: false,
            codeValid: false,
            existingNumberData: '',
            editNumberActive: false,
            codeResendFailed: false,
            codeResent: false,
            triesRemaining: 3,
            counter: 60,
            counterActive: false,
            pinId: ''
        };
    }

    handleVerifyPhone = async () => {
        this.setState({spinnerActive: true, fieldsCheckActive: true})
        let projectId = await this.props.selectedSource || localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';

        setTimeout(async () => {
            let anyErrorActive = !await this.state.formatedPhone;
            await this.state.errorsList.map(error => error ? anyErrorActive = true : '')
            if (!anyErrorActive && this.state.phone && this.state.phone.phone && this.isPhoneNumber()) {
                if (!this.props.editMainPhoneNumber){
                    try {
                        let verifyResult = this.state.editNumberActive ?
                            await http.patch('api/user/' + this.props.user.id + '/project/' + projectId + '/verified_phones/' + this.state.phoneId + '/page_size/8?page=1', {
                                phone_number: this.state.formatedPhone,
                                friendly_name: this.state.friendlyName,
                                country_iso: this.state.phone.iso2.toUpperCase()
                            }, {headers: {authorization: getJwt()}})
                            :
                            await http.post('api/user/' + this.props.user.id + '/project/' + projectId + '/verified_phones/page_size/8?page=1', {
                                verified_phones: [
                                    {
                                        phone_number: this.state.formatedPhone,
                                        friendly_name: this.state.friendlyName,
                                        country_iso: this.state.phone.iso2.toUpperCase()
                                    }
                                ]
                            }, {headers: {authorization: getJwt()}})
                        if(verifyResult && verifyResult.data && verifyResult.data.duplicate_contacts && verifyResult.data.duplicate_contacts.length){
                            toastr.info("Number already added");
                            this.props.handleGetNumbers();
                            await this.setState({spinnerActive: false})
                            this.props.handleClose();
                            this.resetModal();
                        }else if(verifyResult && verifyResult.data && verifyResult.data.verified_phones){
                            this.props.handleGetNumbers();
                            let verifiedPhones = verifyResult.data.verified_phones;
                            let phoneId = '';

                            if(verifiedPhones && verifiedPhones.length){
                                let phoneData = await verifiedPhones.find((phone)=>phone.phone_number === this.state.formatedPhone);
                                phoneId = await phoneData.id
                            }

                            this.setState({
                                activeStep: 2,
                                spinnerActive: false,
                                editNumberActive: false,
                                phoneId: phoneId
                            })
                        }else{
                            this.setState({
                                activeStep: 2,
                                spinnerActive: false,
                                editNumberActive: false,
                            })
                        }
                        // console.log('new tags:', tags);
                    } catch (ex) {
                        toastr.error("Error with adding phone");
                        await this.setState({spinnerActive: false})
                    }
                }else{
                    this.setState({oldFormatedPhone: this.props.user.phone})
                    // console.log('phone test: ', anyErrorActive, this.state.errorsList, this.state.formatedPhone)
                    try {
                        let resp = await http.post('api/user/' + this.props.user.id + '/register_user_valid_phone', {
                            phone: this.state.formatedPhone,
                        }, {headers: {authorization: getJwt()}})

                        await this.props.updateUserFromServer();

                        this.setState({
                            activeStep: 2,
                            spinnerActive: false,
                            pinId: resp?.data?.pinId ?? resp?.data?.data?.pinId
                        });
                    } catch {
                        toastr.error("Error with adding phone");
                        await this.setState({spinnerActive: false})
                    }
                }
            } else {
                await this.setState({spinnerActive: false})
            }
        }, 500)
    };

    handleCodeCheck = async () => {
        let projectId = await this.props.selectedSource || localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        if (!this.props.editMainPhoneNumber){
            try {
                await this.setState({ spinnerActive: true });

                const resp = await http.post('api/user/' + this.props.user.id + '/project/' + projectId + '/verified_phones/verify_workspace_phone', {
                    phone_id: this.state.phoneId,
                    code: this.state.data.sixDigitCode
                }, { headers: { authorization: getJwt() } });

                // console.log('check_user_valid_phone: ', resp)

                let verificationStatus = await resp.data.verification_status;

                if(verificationStatus === 'approved'){
                    await this.setState({
                        spinnerActive: false,
                        codeInvalid: false,
                        codeValid: true
                    });
                    toastr.success("Phone successfully validated.");
                    this.props.handleGetNumbers();
                    this.props.handleClose();
                    this.resetModal();
                } else if(verificationStatus === 'invalid'){
                    toastr.error("Code you entered was invalid, please try again.");
                    this.setState({
                        spinnerActive: false,
                        codeInvalid: true,
                        codeValid: false
                    })
                } else {
                    this.setState({
                        spinnerActive: false,
                    })
                    this.props.handleClose();
                    this.revertToProperUserPhone();
                    this.resetModal();
                }
            } catch {
                toastr.error("Error with code, please try again");
                await this.setState({ spinnerActive: false })
            }
        }else{
            try {
                await this.setState({ spinnerActive: true });
                const resp = await http.post('api/user/' + this.props.user.id + '/check_user_valid_phone', {
                    phone: this.state.formatedPhone,
                    code: this.state.data.sixDigitCode,
                    pinId: this.state.pinId
                }, {headers: {authorization: getJwt()}});

                // console.log('check_user_valid_phone: ', resp)

                let verificationStatus = await resp.data.verification_status;

                if(verificationStatus === 'approved'){
                    await this.setState({
                        spinnerActive: false,
                        codeInvalid: false,
                        codeValid: true
                    });
                    toastr.success("Phone successfully validated.");
                    this.props.updateUserFromServer();
                    this.props.handleClose();
                    this.resetModal();
                } else if(verificationStatus === 'invalid'){
                    toastr.error("Code you entered was invalid, please try again.");
                    this.setState({
                        spinnerActive: false,
                        codeInvalid: true,
                        codeValid: false,
                        triesRemaining: this.state.triesRemaining - 1
                    })
                    if (this.state.triesRemaining === 0) {
                        this.startCounter()
                    }
                } else if(verificationStatus === 'pending'){
                    toastr.error("Please check your code and try again.");
                    this.setState({
                        spinnerActive: false,
                        codeInvalid: true,
                        codeValid: false,
                        triesRemaining: this.state.triesRemaining - 1
                    })
                    if (this.state.triesRemaining === 0) {
                        this.startCounter()
                    }
                } else {
                    this.setState({
                        spinnerActive: false,
                        triesRemaining: this.state.triesRemaining - 1
                    })
                    this.props.handleClose();
                    this.resetModal();
                }
            } catch {
                toastr.error("Error with code, please try again");
                await this.setState({ spinnerActive: false })
            }
        }

    }

    resendConfirmationCode = async () => {
        let projectId = await this.props.selectedSource || localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';

        if (!this.props.editMainPhoneNumber){
            try {
                const resp = await http.post('api/user/' + this.props.user.id + '/project/' + projectId + '/verified_phones/resend_verification_code', {
                    phone_id: this.state.phoneId,
                }, { headers: { authorization: getJwt() } });
                // http.get('api/resend-activation/' + userId, {headers: {authorization: getJwt()}});
                this.setState({ codeResent: true })
            } catch(ex) {
                this.setState({ codeResendFailed: true })
            }
        }else {
            try {
                let resp = await http.post('api/user/' + this.props.user.id + '/register_user_valid_phone', {
                    phone: this.state.formatedPhone,
                }, { headers: { authorization: getJwt() } })

                await this.props.updateUserFromServer();

                this.setState({ codeResent: true, pinId: resp?.data?.pinId ?? resp?.data?.data?.pinId })
            } catch {
                this.setState({ codeResendFailed: true })
            }
        }
    }

    startCounter = () => {
        var counter = 60;
        var interval = setInterval(() => {
            counter--;
            this.setState({counter, counterActive: true})
            if (counter === 0) {
                this.setState({triesRemaining: 3, counter: 60, counterActive: false})
                clearInterval(interval);
            }
        }, 1000);
    }

    resetModal = () => {
        this.setState({
            activeStep: 1,
            friendlyName: '',
            phone: {
                iso2: 'us',
                dialCode: '1',
                phone: ''
            },
            formatedPhone: '',
            oldFormatedPhone: '',
            phoneVerified: '',
            phoneId: '',
            overlayIsOpen: false,
            errorsList: [],
            fieldsCheckActive: false,
            spinnerActive: false,
            codeInvalid: false,
            codeValid: false,
            existingNumberData: '',
            editNumberActive: false,
            codeResendFailed: false,
            codeResent: false,
            triesRemaining: 3,
            counter: 60,
            counterActive: false
        })
    }

    revertToProperUserPhone = async () => {
        try{
            const resp = await http.patch('api/user/' + this.props.user.id + '/osetljivi_korisnikov_broj', {
                phone: this.state.oldFormatedPhone
            }, {headers: {authorization: getJwt()}});
            this.props.updateUserFromServer();
        }catch{
            toastr.error('Saving of phone number was unsuccessful.')
        }
    }

    updateErrorsList = async (error, id) => {
        let errorsList = await this.state.errorsList;
        errorsList[parseInt(id) - 1] = await error;
        await this.setState({errorsList})
        // console.log('errorsList: ', errorsList)
    }

    getFullPhoneNumber = (phoneObject) => {
        let phone = phoneObject.phone.toString();
        let dialCode = phoneObject.dialCode;

        if (phone.startsWith('00')) {
            phone = phone.substring(2);
            phone = '+' + phone;
            return phone
        } else if (phone.startsWith('0')) {
            phone = phone.substring(1);
            phone = '+' + dialCode + phone;
            return phone
        } else if (phone.startsWith('+')) {
            return phone
        } else if (phone && (phone !== '+')) {
            phone = '+' + dialCode + phone;
            return phone
        } else {
            return ''
        }
    }

    isPhoneNumber = () => {
        let phone = this.state.formatedPhone;
        var regEx = /^[+-]?\d+$/;
        if (regEx.test(phone) && phone.length > 6) {
            return true
        } else {
            return false
        }
    }

    componentDidMount() {
        this.setState({
            overlayIsOpen: this.props.showModal
        })
        if(this.props.existingNumberData){
            let data = this.props.existingNumberData;
            this.setState({
                existingNumberData: this.props.existingNumberData,
                activeStep: this.props.editMainPhoneNumber ? 1 : 2,
                friendlyName: data && data.friendly_name ? data.friendly_name : '',
                phone: {
                    iso2: data && data.country_iso ? data.country_iso : 'us',
                    dialCode: '1',
                    phone: data && data.phone_number ? data.phone_number : ''
                },
                formatedPhone: data && data.phone_number ? data.phone_number : '',
                oldFormatedPhone: data && data.phone_number ? data.phone_number : '',
                phoneVerified: data && data.verified ? data.verified : '',
                phoneId: data && data.id ? data.id : '',
            })
        }
    }

    componentDidUpdate() {
        // console.log('state: ', this.state)
        if (this.props.showModal !== this.state.overlayIsOpen) {
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }
        if(this.props.existingNumberData && !this.state.existingNumberData){
            // console.log('existingNumberData: ', this.props.existingNumberData)
            let data = this.props.existingNumberData;
            this.setState({
                existingNumberData: data,
                activeStep: this.props.editMainPhoneNumber ? 1 : 2,
                friendlyName: data && data.friendly_name ? data.friendly_name : '',
                phone: {
                    iso2: data && data.country_iso ? data.country_iso : 'us',
                    dialCode: '1',
                    phone: data && data.phone_number ? data.phone_number : ''
                },
                formatedPhone: data && data.phone_number ? data.phone_number : '',
                oldFormatedPhone: data && data.phone_number ? data.phone_number : '',
                phoneVerified: data && data.verified ? data.verified : '',
                phoneId: data && data.id ? data.id : '',
            })
        }
    }


    render() {
        const inputProps = {
            placeholder: '+' + this.state.phone.dialCode + ' *********',
        };

        const intlTelOpts = {
            preferredCountries: [],
        };

        return (

            <Overlay
                // onClose={this.props.handleClose}
                className={Classes.OVERLAY_SCROLL_CONTAINER}
                // isOpen={this.state.overlayIsOpen}
                isOpen={this.props.showModal}
            >
                <div className="modal-field-payment" style={{width: 500}}>
                    <div className="add-payment-method-modal-container">

                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={()=>{
                                this.props.handleClose();
                                this.revertToProperUserPhone();
                                this.resetModal();
                            }}><i
                                className="fas fa-times"></i></p>
                            <h2>{this.props.editMainPhoneNumber ? 'Verify Phone Number' : 'Verify a Test Number'}</h2>
                        </div>
                        <div className="modal-main">
                            {this.state.activeStep === 1 ?
                                <div className='margin-top-20 margin-bottom-20'>
                                    <p className='margin-bottom-20'>{
                                        this.props.editMainPhoneNumber ?
                                            ""
                                            :
                                            "Add a Phone Number you can use to send out test campaigns before your business gets verified. Enter the phone number and we’ll send you a text with verification code."
                                    }</p>
                                    { !this.props.editMainPhoneNumber ?
                                        <InputRegular
                                            id="1"
                                            label1="Friendly Name"
                                            label2=""
                                            placeholder="Input Friendly Name"
                                            type='text'
                                            onChange={ e => this.setState({ friendlyName: e }) }
                                            value={ this.state.friendlyName }
                                            updateErrorsList={ this.updateErrorsList }
                                            errorMessage="A friendly name can't be empty."
                                            fieldsCheckActive={ this.state.fieldsCheckActive }
                                            required={ true }
                                        />
                                        :
                                        ''
                                    }
                                    <p htmlFor="post-link" className='full-row-label'>Phone</p>
                                    <ReactIntlTelInput
                                        className={((this.state.phone.phone === '') || !this.isPhoneNumber()) && this.state.fieldsCheckActive ? 'onboard-tel error' : this.state.phone.phone === '' ? '' : 'onboard-tel valid'}
                                        inputProps={inputProps}
                                        intlTelOpts={intlTelOpts}
                                        value={this.state.phone}
                                        onChange={(e) => {
                                            this.setState({
                                                phone: e,
                                                formatedPhone: this.getFullPhoneNumber(e)
                                            })
                                        }}
                                    />
                                    {
                                        ((this.state.phone.phone === '') || !this.isPhoneNumber()) && this.state.fieldsCheckActive ?
                                            <div className="selector-error-label">Valid phone number is required</div>
                                            :
                                            <div className='selector-error-label'></div>
                                    }
                                    <div className='justify-content-end flex-direction-row margin-top-20 margin-bottom-20'>

                                        <button disabled={false}
                                                onClick={()=>{
                                                    this.props.handleClose();
                                                    this.revertToProperUserPhone();
                                                    this.resetModal();
                                                }}
                                                name="cancel_tag"
                                                id="cancel_tag"
                                                type="button"
                                                className='btn-white-border btn-small margin-right-10'>Cancel
                                        </button>

                                        {!this.state.spinnerActive ?
                                            <button className="btn-action btn-small"
                                                    onClick={this.handleVerifyPhone}>Text Me</button>
                                            :
                                            <button className="btn-action btn-spinner btn-small" disabled={true}>Text Me <i
                                                className='fa fa-spin fa-spinner'></i></button>
                                        }

                                    </div>
                                </div>
                                :
                                <div className='margin-top-20 margin-bottom-20'>
                                    <p className='margin-bottom-20'>Check your phone!<br/>
                                        We’ve sent a 6-digit confirmation code to <strong>{this.state.formatedPhone}</strong><br/>
                                        It will expire shortly, so enter it soon.
                                    </p>

                                    <ReactCodeInput
                                        // fieldHeight='80px'
                                        // fieldWidth='60px'
                                        disabled={this.state.counterActive}
                                        onChange={async (value) => await this.setState({
                                            data: {sixDigitCode: value},
                                            codeInvalid: false,
                                        })}
                                        onComplete={async (value) => {
                                            await this.setState({
                                                data: {sixDigitCode: value}
                                            })
                                            await this.handleCodeCheck()
                                        }}
                                        autoFocus={true}
                                        className={this.state.codeInvalid ? 'verification-code-invalid' : 'verification-code'}
                                    />
                                    { this.state.spinnerActive || (this.state.codeInvalid || this.state.counterActive) || this.state.codeValid ?
                                        <div className='margin-bottom-30'/>
                                        :
                                        ''
                                    }
                                    {
                                        this.state.spinnerActive ?
                                            <InputNotification type={'loading'} text={'Validating your code...'}/> :
                                            this.state.codeInvalid || this.state.counterActive ?
                                                <InputNotification type={'danger'}
                                                                   text={this.state.counterActive ?
                                                                       'That code wasn’t valid. Give it another try! ( 0 attempts remaining, you need to wait ' + this.state.counter + ' seconds)'
                                                                       :
                                                                       'That code wasn’t valid. Give it another try! (' + this.state.triesRemaining + ' attempts remaining)'}/>
                                                :
                                                this.state.codeValid ?
                                                    <InputNotification type={'success'}
                                                                       text={'You successfully confirmed your phone number'}/> : null
                                    }

                                    <p className='margin-top-20 margin-bottom-20'>Do not close this pop-up before you enter the code.<br/>
                                        Didn’t receive an SMS? { this.state.codeResendFailed ?
                                            <span className={ 'red-text' }>Error with Confirmation code resending</span> :
                                            this.state.codeResent ?
                                                <span className={ 'green-text' }>Confirmation code was resent</span> :
                                                <a onClick={ this.resendConfirmationCode }>Resend confirmation code</a>
                                        }
                                    </p>


                                    <div className='justify-content-end flex-direction-row margin-top-20 margin-bottom-20'>

                                        <button disabled={false}
                                                onClick={()=>this.setState({activeStep: 1, editNumberActive: true})}
                                                name="cancel_tag"
                                                id="cancel_tag"
                                                type="button"
                                                className='btn-white-border btn-small margin-right-10'>Back
                                        </button>

                                        {!this.state.spinnerActive ?
                                            <button className="btn-action btn-small"
                                                    onClick={this.handleCodeCheck}>Verify</button>
                                            :
                                            <button className="btn-action btn-spinner btn-small" disabled={true}>Verify <i
                                                className='fa fa-spin fa-spinner'></i></button>
                                        }

                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}

export default VerifyNumberModal;